"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var pomodoroContext_1 = __importDefault(require("./pomodoroContext"));
var PomodoroPopover_1 = __importDefault(require("./PomodoroPopover"));
var PomodoroButton_1 = __importDefault(require("./PomodoroButton"));
var PomodoroFocusAlertOverlay_1 = __importDefault(require("./PomodoroFocusAlertOverlay"));
var PomodoroPopoverContainer = function (_a) {
    var children = _a.children;
    var _b = react_1.useContext(pomodoroContext_1.default), mode = _b.mode, popoverOpen = _b.popoverOpen, studyMode = _b.studyMode, openPopover = _b.openPopover, closePopover = _b.closePopover, paused = _b.paused, remainingTime = _b.remainingTime, playFocusAlertSound = _b.playFocusAlertSound;
    var ref = react_1.useRef(null);
    var _c = __read(react_1.useState(), 2), soundInterval = _c[0], setSoundInterval = _c[1];
    var _d = __read(react_1.useState(false), 2), windowBlurred = _d[0], setWindowBlurred = _d[1];
    var _e = __read(react_1.default.useState(null), 2), anchorEl = _e[0], setAnchorEl = _e[1];
    var focusAlert = studyMode && windowBlurred && mode === 'focus' && !paused;
    react_1.useEffect(function () {
        function onFocus() {
            setWindowBlurred(false);
        }
        function onBlur() {
            setWindowBlurred(true);
        }
        window.addEventListener('focus', onFocus);
        window.addEventListener('blur', onBlur);
        return function () {
            window.removeEventListener('focus', onFocus);
            window.removeEventListener('blur', onBlur);
        };
    }, []);
    react_1.useEffect(function () {
        if (focusAlert && !soundInterval) {
            playFocusAlertSound();
            var interval = setInterval(function () {
                playFocusAlertSound();
            }, 2000);
            setSoundInterval(interval);
        }
        else if (!focusAlert && soundInterval) {
            clearInterval(soundInterval);
            setSoundInterval(null);
        }
    }, [playFocusAlertSound, focusAlert, soundInterval]);
    react_1.useEffect(function () {
        if (ref.current) {
            setAnchorEl(ref.current);
        }
    }, [ref]);
    return (react_1.default.createElement("div", { ref: ref },
        focusAlert && react_1.default.createElement(PomodoroFocusAlertOverlay_1.default, null),
        react_1.default.createElement(PomodoroButton_1.default, { time: remainingTime, mode: mode, onClick: openPopover }),
        react_1.default.createElement(PomodoroPopover_1.default, { open: popoverOpen, onClose: closePopover, anchorEl: anchorEl }, children)));
};
exports.default = PomodoroPopoverContainer;
//# sourceMappingURL=PomodoroPopoverContainer.js.map